export * from './blogTableConfig';